import React from "react";
import IconContext from "./IconContext";
import PropTypes from 'prop-types';

interface IconProviderProps {
    children: React.ReactNode;
    svgs: any;
}

/**
 * A wrapper for an application to allow passing in SVGs to other `cai-fusion` components.
 * 
 * ## _
 * ### Arguments
 * @param {React.ReactNode} children - This should be the app you're wrapping.
 * @param {object} svgs - This should be a collection of SVGs. For each Fusion component you are using, make sure the icon listed in documentation exists in this object, under the same name.
 */
class IconProvider extends React.Component<IconProviderProps> {
    static propTypes = {
        children: PropTypes.node,
        svgs: PropTypes.any,
    }

    render() {
        const { children, svgs } = this.props;

        return (
            <IconContext.Provider value={svgs}>
                {children}
            </IconContext.Provider>
        );
    };
}

export default IconProvider;